import { Component, Input, OnInit } from '@angular/core';
import { LeadHistoryAuditItemBase } from '../audit-item.base';
import { AuditItemLogInput } from './audit-item-log-input.model';

@Component({
    selector: 'app-audit-item-log',
    templateUrl: './audit-item-log.component.html',
    styleUrls: ['./audit-item-log.component.scss'],
    standalone: false
})
export class AuditItemLogComponent extends LeadHistoryAuditItemBase implements OnInit {

  log: AuditItemLogInput | undefined = undefined

  @Input() set input(input: AuditItemLogInput) {
    this.log = input
  }

  constructor() { super() }

  ngOnInit(): void {
  }

  getSeverityClass() {
    if (this.log!.severity && this.log!.severity.trim()) {
      switch (this.log!.severity.toLocaleLowerCase()) {
        case 'info':
          return 'infoSeverity'
          break;
        case 'error':
          return 'errorSeverity'
          break;
        case 'warning':
          return 'warningSeverity'
          break;

        default:
          return 'noSeverity'
          break;
      }
    }
    else {
      return 'noSeverity'
    }
  }
}
